// Google Ads conversion helper
export const AW_ID = "AW-608571944";

// Fires a Google Ads conversion. Pass a conversion label (from Google Ads) when
// available -> send_to becomes "AW-608571944/<label>". Without a label it still
// registers under the account tag.
export const trackConversion = (label, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", {
    send_to: label ? `${AW_ID}/${label}` : AW_ID,
    ...params,
  });
};

// Conversion label(s) from Google Ads (Conversions).
export const CONVERSION_LABELS = {
  leaseIntentClick: "dR0qCOr2nvMcEKikmKIC", // "Quero alugar um espaço" button click
  leaseFormSubmit: "dR0qCOr2nvMcEKikmKIC", // Lease proposal form submitted
};

export const trackLeaseIntentClick = () => {
  trackConversion(CONVERSION_LABELS.leaseIntentClick, { value: 1.0, currency: "BRL", event_label: "quero_alugar_click" });
};

export const trackLeaseFormSubmit = () => {
  trackConversion(CONVERSION_LABELS.leaseFormSubmit, { value: 1.0, currency: "BRL", event_label: "proposta_locacao_enviada" });
};
